import React from 'react';
import { type PatientTableItem } from 'types/types';

import styles from './styles.module.sass';

type Props = {
  size: number;
} & Partial<PatientTableItem>;

export const AvatarCell: React.FC<Props> = ({ firstName, lastName, avatarUri, size }) => {
  if (!avatarUri) {
    return (
      <div className={styles.avatar_name} style={{ width: size, height: size }}>
        {firstName ? `${firstName[0].toUpperCase()}.` : 'N/A'} {lastName ? `${lastName[0].toUpperCase()}.` : ''}
      </div>
    );
  }

  return <img className={styles.avatar_image} src={avatarUri} style={{ width: size, height: size }} alt='avatar' />;
};
